export enum GetExtractionsTarget {
  EXTRACTIONS = 'Extractions',
  OVERVIEW = 'Overview',
}

export enum ExtractionFormat {
  SHORT = 'ShortConcise',
  MEDIUM = 'Medium',
}

export enum ExtractionTemplateOwnershipEnum {
  VOLVE = 10,
  YOU = 20,
  ORGANIZATION = 30,
}

export const EXTRACTIONS_ORDER_FIELDS = ['status'] as const;
